import { EntityDeadlineStatus } from '../../../Entity'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

function TableDueDateCell({
  getColorProperties,
  status,
  unread,
  value,
  ...cellProps
}) {
  return value ? (
    <TableCellBase {...cellProps}>
      <EntityDeadlineStatus
        deadline={value}
        getColorProperties={getColorProperties}
        status={status}
      />
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} unread={unread} />
  )
}

export default TableDueDateCell
